// extracted by mini-css-extract-plugin
export default {"headingStyles":"styles_headingStyles__pilSl"};